import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import {jwtDecode} from "jwt-decode";

export const SalesProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user) {
    // user is not authenticated
    return <Navigate to="/" />;
  }
  else if (user.token) {
    const decoded = jwtDecode(user.token);
    const userInfo = decoded.id;
    if (userInfo[1] !== 'RCPSales') {
      return <Navigate to="/" />;
    }
  }
  return children;
};